import { SEO, FAQS } from '../data';

/**
 * SeoJsonLd — inyecta JSON-LD (Organization + SoftwareApplication + FAQPage)
 * para SEO y para que ChatGPT/Perplexity/Google citen a LeadCEM. Fuente: data.js (SEO, FAQS).
 * Solo datos verificables; sin métricas inventadas.
 */
export default function SeoJsonLd() {
  const graph = [
    {
      '@type': 'Organization',
      '@id': SEO.url + '#org',
      name: SEO.name,
      url: SEO.url,
      logo: SEO.logo,
    },
    {
      '@type': 'SoftwareApplication',
      name: SEO.name,
      applicationCategory: SEO.category,
      operatingSystem: 'Web',
      description: SEO.description,
      offers: { '@type': 'Offer', priceCurrency: 'MXN', price: '0', description: 'Planes por giro y volumen — cotización a la medida.' },
      publisher: { '@id': SEO.url + '#org' },
    },
    {
      '@type': 'FAQPage',
      mainEntity: FAQS.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    },
  ];
  const json = { '@context': 'https://schema.org', '@graph': graph };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }} />;
}
